import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { AssistanceListDTO } from "../models/Assistance/AssistanceListDTO";
import { Parameter } from "../models/Parameter";
import { ProjectProfitabilityDTO } from "../models/Profitability/ProjectProfitabilityDTO";
import { ProjectProfitabilityParametersDTO } from "../models/Profitability/ProjectProfitabilityParametersDTO";
import { CreateProjectDTO } from "../models/Project/CreateProjectDTO";
import { EditProjectDTO } from "../models/Project/EditProjectDTO";
import { EquipmentsFromProjectRequestDTO } from "../models/Project/EquipmentsFromProjectRequestDTO";
import { EquipmentsFromProjectResponseDTO } from "../models/Project/EquipmentsFromProjectResponseDTO";
import { GetAssistanceFromProjectDTO } from "../models/Project/GetAssistancesFromProjectDTO";
import { ProjectDTO } from "../models/Project/ProjectDTO";
import { SearchByProject } from "../models/Project/SearchByProject";
import { APIService } from "./APIService";

export class ProjectService {
  async GetAllFromErp(
    searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number
  ): Promise<PaginatedList<ProjectDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Project/GetAllFromErp`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<ProjectDTO>(
        false,
        "Erro ao obter a informação das obras",
        "",
        [],
        0
      );
    }
  }

  async GetByProject(
    searchParams: SearchByProject
  ): Promise<MessagingHelper<ProjectDTO[] | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Project/GetByProject`,
        {
          ...searchParams,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao obter a informação das obras",
        null
      );
    }
  }

  async Create(
    createProject: CreateProjectDTO
  ): Promise<MessagingHelper<string>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Project/Create`,
        {
          ...createProject,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );

      return response.data;
    } catch (error) {
      return new MessagingHelper<string>(false, "Erro ao criar a obra", "");
    }
  }

  async Edit(projectUpdate: EditProjectDTO): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Project/Edit`,
        { ...projectUpdate },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para atualizar a obra",
        null
      );
    }
  }

  async GetByIdErp(idErp: string): Promise<MessagingHelper<ProjectDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Project/GetByIdErp/${idErp}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao obter a informação da obra",
        null
      );
    }
  }

  //rentabilidade
  async GetProjectProfitability(
    data: ProjectProfitabilityParametersDTO
  ): Promise<MessagingHelper<ProjectProfitabilityDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Project/GetProjectProfitability`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<any>(
        false,
        "Erro ao obter a rentabilidade da obra",
        null
      );
    }
  }

  async GetAssistancesFromProject(
    search: GetAssistanceFromProjectDTO
  ): Promise<PaginatedList<AssistanceListDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Project/GetAssistancesFromProject`,
        {
          ...search,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<AssistanceListDTO>(
        false,
        "Ocorreu um erro ao obter as assistências da obra",
        "",
        [],
        0
      );
    }
  }

  async GetEquipmentsFromProject(
    search: EquipmentsFromProjectRequestDTO
  ): Promise<PaginatedList<EquipmentsFromProjectResponseDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Project/GetEquipmentsFromProject`,
        {
          ...search,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<EquipmentsFromProjectResponseDTO>(
        false,
        "Ocorreu um erro ao obter os equipamentos da obra",
        "",
        [],
        0
      );
    }
  }

}
